// extracted by mini-css-extract-plugin
module.exports = {"modal":"AuthWindow_modal__aEj5N","auth":"AuthWindow_auth__3d5NH","icon":"AuthWindow_icon__2asvr"};